import React, { Component } from "react";
import {
  Box,
  Container
} from "@mui/material";
import {
  ProfileInfo,
  BalanceInfo,
  FormFeedback,
  SelectLanguages
} from "./components";

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount = () => {}

  render() {
    return (
      <Container>
        <ProfileInfo/>
        <Box mt={3}/>
        <SelectLanguages/>
        <Box mt={3}/>
        <BalanceInfo/>
        <Box mt={10}/>
        <FormFeedback/>
      </Container>
    );
  }
}

export default Profile
